/* tslint:disable */
/* eslint-disable */
/**
 * Mild Blue s.r.o. - Online Connect
 * Application allowing people to ask for admition in IKEM.
 *
 * The version of the OpenAPI document: development
 * Contact: support@mild.blue
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { PhoneNumberDto } from './phone-number-dto';

/**
 * 
 * @export
 * @interface PatientInfoDtoIn
 */
export interface PatientInfoDtoIn {
    /**
     * 
     * @type {string}
     * @memberof PatientInfoDtoIn
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInfoDtoIn
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInfoDtoIn
     */
    insuranceCompany: PatientInfoDtoInInsuranceCompanyEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInfoDtoIn
     */
    insuranceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInfoDtoIn
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInfoDtoIn
     */
    note: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInfoDtoIn
     */
    personalNumber: string;
    /**
     * 
     * @type {PhoneNumberDto}
     * @memberof PatientInfoDtoIn
     */
    phoneNumber: PhoneNumberDto;
    /**
     * 
     * @type {string}
     * @memberof PatientInfoDtoIn
     */
    titleAfter: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInfoDtoIn
     */
    titleBefore: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PatientInfoDtoInInsuranceCompanyEnum {
    Vzp = 'VZP',
    Vozp = 'VOZP',
    Cpzp = 'CPZP',
    Ozp = 'OZP',
    Zps = 'ZPS',
    Zpmv = 'ZPMV',
    Rbp = 'RBP',
    Other = 'OTHER'
}



